module.exports = __webpack_public_path__ + "img/02-4.28cee043.png";